import { render, staticRenderFns } from "./ChatGroupMember.vue?vue&type=template&id=1fe8b0a6&scoped=true"
import script from "./ChatGroupMember.vue?vue&type=script&lang=js"
export * from "./ChatGroupMember.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupMember.vue?vue&type=style&index=0&id=1fe8b0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe8b0a6",
  null
  
)

export default component.exports